import { Observable } from 'rxjs/Observable'

import { BaseModel, ModelRepositoryAdapter  } from '../../../'
import { ModelFactory } from '../../../data/factories'

export class CreateByTypeStrategy {
  public get registrationType(): string {
    return this._modelType
  }

  public constructor(
    private _typeService: ModelRepositoryAdapter<BaseModel>,
    private _modelFactory: ModelFactory,
    private _modelType: string,
    private _typeKey: string
  ) {}

  public createByType(typeId: string): Observable<BaseModel> {
    const model = this._modelFactory.instantiateClass(this._modelType)
    return this._typeService.findModelById(typeId).map((type) => {
      model[this._typeKey] = type
      return model
    })
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/factories/strategies/create-by-type/create-by-type.strategy.ts